import type { WorkspaceMember } from '@/types/workspace';

/** A workspace member's display label: displayName, falling back to email. */
export function getMemberLabel(member: WorkspaceMember): string {
  return member.displayName ?? member.email;
}
